export default "__VITE_ASSET__Bw5YWrkl__"